import { resolveFlagEnabled } from './permissionFlagResolver'

const CO_ROLES = new Set([
  'compliance_officer',
  'compliance_manager',
  'compliance officer',
  'compliance manager',
  'mlro',
])

export const CO_RUN_PATH = '/compliance-safe/run'
export const CO_RUN_FLAG = 'page:compliance-safe/run'

export function isComplianceOperator(user, roles = []) {
  const list = [
    ...(Array.isArray(roles) ? roles : []),
    user?.role,
    ...(Array.isArray(user?.roles) ? user.roles : []),
  ]
  return list.some((r) => CO_ROLES.has(String(r || '').trim().toLowerCase()))
}

export function isCoRunEnabled(flags) {
  return resolveFlagEnabled(flags, CO_RUN_FLAG)
}

export function postLoginHomePath(user, roles, flags) {
  if (isComplianceOperator(user, roles) && isCoRunEnabled(flags)) {
    return CO_RUN_PATH
  }
  return '/dashboard'
}

/** Same as postLoginHomePath but only returns CO run when that page flag is enabled. */
export function postLoginHomePathSafe(user, roles, flags) {
  const target = postLoginHomePath(user, roles, flags)
  if (target === CO_RUN_PATH && !isCoRunEnabled(flags)) return '/dashboard'
  return target
}
